import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { IAfterGuiAttachedParams, ICellRendererParams } from 'ag-grid-community';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-toggledependency',
  templateUrl: './toggledependency.component.html',
  styleUrls: ['./toggledependency.component.scss']
})
export class ToggledependencyComponent implements OnInit {
  public sessionStorage = sessionStorage;
  status: boolean;
  constructor(private commonServ: CommonService, private _snackBar: MatSnackBar) { }

  ngOnInit(): void {
  }

  refresh(params: ICellRendererParams): boolean {
    debugger
    throw new Error("Method not implemented.");
  }
  afterGuiAttached?(params?: IAfterGuiAttachedParams): void {
    throw new Error("Method not implemented.");
  }
  private params: any;

  paramsdata: any;
  agInit(params: any): void {
    console.log(params['data'])
    this.paramsdata = params['data']
    this.status = params.value;
    this.params = params;
  }
  toggleStatusDependency(event) {
    console.log("x", event)
    this.status = event.checked;
    this.paramsdata['enabled_flag'] = this.status
    console.log('this.paramsdata', this.paramsdata)
    this.commonServ.updatestatus(this.paramsdata).subscribe((response) => {
      if (this.status) {
        this._snackBar.open('Status Enable Successfully', "Close", {
          duration: 2000,
          verticalPosition: 'top',
          horizontalPosition: 'center',
        });
      } else if (!this.status) {
        this._snackBar.open('Status Disable Successfully', "Close", {
          duration: 2000,
          verticalPosition: 'top',
          horizontalPosition: 'center',
        });
      }

    })
  }


}
